export default function NoWarranty() {
  return (
    <div className="mt-24 border-4 border-yellow-400 bg-yellow-100 p-4 text-xl">
      We do our best to provide high quality data and try to remove wrong data entry. However,&nbsp;
      <span className="font-semibold">
        we make no warranties for our data and other calculation programs.
      </span>
      &nbsp;KDB project team shall not be liable for any damage tha may result from errors or ommisions in the
      database.
    </div>
  );
}
